// @flow
import type {Element, Node} from 'react'
import React from 'react'

import AppLink from 'components/ui/AppLink'
import {header, linkToNote} from './index.scss'

type Props = {
  children: Node,
  samePageTarget?: boolean,
  url: string,
}

const newTabParams = {
  target: '_blank',
  rel: 'noopener noreferrer',
}

function Header({children, samePageTarget = false, url}: Props): Element<"div"> {
  const optionalParams = {
    ...(samePageTarget ? null : newTabParams),
  }

  return (
    <div className={header}>
      <h4>
        <AppLink className={linkToNote} href={url} {...optionalParams}>
          {children}
        </AppLink>
      </h4>
    </div>
  )
}

export default Header
